module.exports = __webpack_public_path__ + "img/stock4.4d0bd767.png";